var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-tabs',{attrs:{"lazy":""}},[_c('b-tab',{attrs:{"title":"Stats:","disabled":""}}),_c('b-tab',{attrs:{"title":"Kpi","title-link-class":"text-info"}},[_c('ulu-agents-range-table')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }